import { FormControl, TextField } from "@material-ui/core";
import React from "react";

export function CTextField({
  name,
  label,
  onChange,
  onBlur,
  value,
  defaultValue,
  error,
  type,
  props,
  InputProps,
  InputLabelProps,
  fullWidth,
  required,
  disabled,
  className,
  onClick,
  multiline,
  style,
  placeholder,
  rows,
  key,
}) {
  return (
    <FormControl className={className ?? ""} fullWidth={fullWidth ?? false}>
      <TextField
        size="small"
        variant="outlined"
        name={name}
        label={label}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        type={type ?? "text"}
        value={value}
        defaultValue={defaultValue}
        error={error}
        inputProps={props}
        InputProps={InputProps}
        rows={rows}
        InputLabelProps={
          InputLabelProps ?? (type === "date" ? { shrink: true } : undefined)
        }
        multiline={multiline}
        required={required ?? false}
        disabled={disabled ?? false}
        className={className ?? ""}
        onClick={onClick ?? null}
        style={style}
        key={key}
      />
    </FormControl>
  );
}
